interface CoachTeamData {
  id?: number;
  coachId?: number;
  teamId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
}


export class CoachTeam {
  public static getNonTranslatableFields(): string[] { return ['id', 'coachId', 'teamId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'coachId', 'teamId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  coachId?: number;
  teamId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  public static fromAPI(data: CoachTeamData): CoachTeam {
    return new CoachTeam(data);
  }

  public static fromAPIList(data: CoachTeamData[]): CoachTeam[] {
    return data.map((item: CoachTeamData) => CoachTeam.fromAPI(item));
  }

  constructor({id, coachId, teamId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId} : CoachTeamData) {
    this.id = id;
    this.coachId = coachId;
    this.teamId = teamId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): CoachTeamData {
    return {
      id: this.id,
      coachId: this.coachId,
      teamId: this.teamId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }


}
